$(document).ready(function(){
  $("#embroidary").change(function(){
    var x = $(this).val();
    if(x == 'Yes'){
      $(this).parent().addClass("yes");
    }else{
      $(this).parent().removeClass("yes");
    }
  });
});

(() => {
  const isProductPage = () => Boolean(document.querySelector('product-form form[action*="/cart/add"]'));
  const isEmbroideryTemplate = () => Boolean(document.querySelector('product-embroidery, .product-embroidery'));

  const uploadLiftSelectors = [
    '[data-upload-lift]',
    '[data-cloudlift]',
    '[class*="upload-lift" i]',
    '[id*="upload-lift" i]',
    '[class*="cloudlift" i]',
    '[id*="cloudlift" i]',
    '[class*="cl-upload" i]',
    '[id*="cl-upload" i]',
    'input[name="properties[upload]"]',
    'input[name="properties[Upload]"]',
    'input[name="properties[Logo]"]'
  ];

  const uploadLiftContainerSelectors = [
    '[data-upload-lift]',
    '[data-cloudlift]',
    '[class*="upload-lift" i]',
    '[id*="upload-lift" i]',
    '[class*="cloudlift" i]',
    '[id*="cloudlift" i]',
    '[class*="cl-upload" i]',
    '[id*="cl-upload" i]',
    '.shopify-block'
  ].join(',');

  const removeUploadLiftEmbeds = () => {
    if (!isProductPage() || isEmbroideryTemplate()) return;

    document.querySelectorAll(uploadLiftSelectors.join(',')).forEach((element) => {
      // upload lift safeguard: app embed is only allowed on product.embroidery.
      const container = element.closest(uploadLiftContainerSelectors) || element;
      container.remove();
    });
  };

  document.addEventListener('DOMContentLoaded', removeUploadLiftEmbeds);
  removeUploadLiftEmbeds();

  const uploadLiftObserver = new MutationObserver(removeUploadLiftEmbeds);
  uploadLiftObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
